/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DiscoverPageRequest } from '../models/DiscoverPageRequest';
import type { DiscoverSection } from '../models/DiscoverSection';
import { request as __request } from '../core/request';

export class MainService {

    /**
     * Get Discover Page Old
     * @result DiscoverSection Successful Response
     * @throws ApiError
     */
    public static async getDiscoverPageOld(): Promise<Array<DiscoverSection>> {
        const result = await __request({
            method: 'GET',
            path: `/main/discover_page_old`,
            errors: {
                422: `Validation Error`,
            },
        });
        return result.body;
    }

    /**
     * Get Discover Page Old
     * @param requestBody
     * @result DiscoverSection Successful Response
     * @throws ApiError
     */
    public static async getDiscoverPageOld1({
        requestBody,
    }: {
        requestBody?: DiscoverPageRequest,
    }
): Promise<Array<DiscoverSection>> {
    const result = await __request({
        method: 'POST',
        path: `/main/discover_page_old`,
        body: requestBody,
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * Get Discover Page
 * @param refresh
 * @param userAgent
 * @param cloudfrontIsMobileViewer
 * @result DiscoverSection Successful Response
 * @throws ApiError
 */
public static async getDiscoverPage({
    refresh = false,
    userAgent,
    cloudfrontIsMobileViewer,
}: {
    refresh?: boolean,
    userAgent?: string,
    cloudfrontIsMobileViewer?: string,
}
): Promise<Array<DiscoverSection>> {
    const result = await __request({
        method: 'GET',
        path: `/main/discover_page`,
        headers: {
            'user-agent': userAgent,
            'cloudfront-is-mobile-viewer': cloudfrontIsMobileViewer,
        },
        query: {
            'refresh': refresh,
        },
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * Get Discover Page
 * @param refresh
 * @param userAgent
 * @param cloudfrontIsMobileViewer
 * @param requestBody
 * @result DiscoverSection Successful Response
 * @throws ApiError
 */
public static async getDiscoverPage1({
    refresh = false,
    userAgent,
    cloudfrontIsMobileViewer,
    requestBody,
}: {
    refresh?: boolean,
    userAgent?: string,
    cloudfrontIsMobileViewer?: string,
    requestBody?: DiscoverPageRequest,
}
): Promise<Array<DiscoverSection>> {
    const result = await __request({
        method: 'POST',
        path: `/main/discover_page`,
        headers: {
            'user-agent': userAgent,
            'cloudfront-is-mobile-viewer': cloudfrontIsMobileViewer,
        },
        query: {
            'refresh': refresh,
        },
        body: requestBody,
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * Clear Discover Cache
 * @result any Successful Response
 * @throws ApiError
 */
public static async clearDiscoverCache(): Promise<any> {
    const result = await __request({
        method: 'GET',
        path: `/main/clear_discover_cache`,
    });
    return result.body;
}

/**
 * Headers Testing
 * @param cloudfrontIsMobileViewer
 * @result any Successful Response
 * @throws ApiError
 */
public static async headersTesting({
    cloudfrontIsMobileViewer,
}: {
    cloudfrontIsMobileViewer?: string,
}
): Promise<any> {
    const result = await __request({
        method: 'GET',
        path: `/main/headers_testing`,
        headers: {
            'cloudfront-is-mobile-viewer': cloudfrontIsMobileViewer,
        },
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

}